const resumeData = {
  name: "Sydney Ferris",
  title: "Software Engineer",
  contact: {
    website: "https://sydneyferris.com",
    linkedin: "https://www.linkedin.com/in/sydney-ferris",
    github: "https://github.com/SydZero"
  },
  summary: "Fullstack software engineer with 2 years of experience building and maintaining web applications in an enterprise IT environment. Passionate about writing clean, scalable code and collaborating with cross-functional teams. Eager to deepen expertise across the stack and contribute to impactful products.",
  experience: [
    {
      title: "Software Engineer",
      company: "Dell Technologies",
      location: "Round Rock, TX",
      startDate: "2025-02",
      endDate: "Present",
      description: [
        "Develop and maintain full-stack tooling that renders CMS content into over 30,000 customer-facing pages on Dell.com using C#",
        "Maintained a suite of 8 apps responsible for over $1.3 billion in revenue",
        "Collaborate globally with 10+ cross-functional teams to build and improve internal tooling across the full development lifecycle",
        "Reduced CI/CD pipeline runtime by 40% while increasing test coverage, cutting infrastructure costs and development time",
        "Drive AI-native SDLC and spec-driven development for desktop applications using structured requirements and documentation"
      ]
    },
    {
      title: "Software Engineer Intern",
      company: "Dell Technologies",
      location: "Round Rock, TX",
      startDate: "2024-05",
      endDate: "2024-08",
      description: [
        "Contributed to the development of an application architected to deliver customized web pages with 80% faster turnaround",
        "Increased automated test coverage by 60%, strengthening application reliability and laying a strong testing foundation",
        "Built full-stack features using C#, CSHTML, LESS, and JavaScript across the complete development lifecycle"
      ]
    },
    {
      title: "Open Education Resources Student Technician",
      company: "Texas A&M University",
      location: "College Station, TX",
      startDate: "2023-08",
      endDate: "2024-12",
      description: [
        "Selected by faculty to maintain and support auto-grading software, ensuring reliable and efficient assessment for 300+ students",
        "Develop affordable, accessible learning resources that lower barriers to computer science education for a diverse student body"
      ]
    },
    {
      title: "Peer Teacher",
      company: "Texas A&M University",
      location: "College Station, TX",
      startDate: "2023-01",
      endDate: "2023-05",
      description: [
        "Mentored 200+ students through problem-solving in introductory C++, fostering independent thinking and technical confidence",
        "Provided structured feedback weekly on curriculum content and develop educational materials to enhance the learning experience"
      ]
    },
    {
      title: "ITDP Committee Lead",
      company: "Dell Technologies",
      location: "Round Rock, TX",
      startDate: "2025-08",
      endDate: "Present",
      description: [
        "Collaborate with a global team to produce a quarterly newsletter, coordinating across 7 time zones to meet consistent deadlines",
        "Manage and delegate tasks to a team of 6 to continuously update, maintain, and improve the committee's SharePoint site",
        "Design and develop promotional materials for networking and professional development events",
        "Serve as the primary point of contact for SharePoint content updates, ensuring accurate and timely information for stakeholders"
      ]
    }
  ],
  education: [
    {
      degree: "Bachelor of Science in Computer Science, Cybersecurity Minor",
      school: "Texas A&M University",
      location: "College Station, TX",
      startDate: "2021-01",
      endDate: "2024-12",
      gpa: "3.938",
      honors: "Summa Cum Laude",
      courses: [
        "Cloud Computing",
        "Artificial Intelligence",
        "Cybersecurity Law and Policy",
        "Design and Analysis of Algorithms",
        "Cryptography",
        "Foundations of Software Engineering",
        "Principles of Statistics",
        "Data Structures and Algorithms",
        "Computer Organization",
        "Program Design and Concepts"
      ]
    }
  ],
  skills: [
    "C#", "C/C++", "Python", "HTML", "CSS", "JavaScript", "Java", "LESS", "React",
    "ASP.NET", "CI/CD", "AWS", "SharePoint", "Jira", "Confluence", "Selenium", "Git", "GitHub", "GitLab", "Windsurf",
    "Full-Stack Development", "CMS Integration", "Agile Development", "Testing Strategies"
  ],
  projects: [
    {
      name: "Personal Website",
      link: "https://sydneyferris.com",
      description: "Personal website built with React and deployed to AWS S3",
      technologies: ["React", "AWS S3"]
    },
    {
      name: "F1 Data Visualization Dashboard",
      link: "https://sydneyferris.com/f1",
      description: [
        "A full-stack F1 analytics application in React.js, using FastF1 and Kaggle datasets to visualize 70+ years of racing data",
        "Architect cloud infrastructure using AWS S3 and CloudFront for content delivery, with GitHub Actions automating data refreshes",
        "Leverage agentic AI coding tools to develop and maintain the application"
      ],
      technologies: ["React", "Kaggle", "Github Actions", "AWS S3", "CloudFront", "Agentic AI Coding Tools"]
    },
    {
      name: "Fun Facts Database",
      link: "https://sydneyferris.com/fun-facts-display",
      description: [
        "React.js app with Google OAuth and Firebase Firestore for users to submit and browse categorized facts, featuring admin approval"
      ],
      technologies: ["React", "Firebase", "Google OAuth"]
    },
    {
      name: "NCAR Chemistry Cafe",
      description: [
        "Developed C# managed database application with storage and retrieval capabilities for scientific data analysis and management."
      ],
      technologies: ["C#", "Database Management"]
    }
  ]
};

export default resumeData;
